export default __webpack_public_path__ + "static/media/successNew.fd2c2fea.mp3";